import { createGlobalStyle } from 'styled-components';

// Bold Monochrome Design System - Global Styles
export const GlobalStyles = createGlobalStyle`
  /* Bold Monochrome Grid Background Pattern */
  .sk-grid-background {
    background-color: var(--bg-primary, #fafafa);
    background-image:
      linear-gradient(var(--grid-color, rgba(0, 0, 0, 0.08)) 2px, transparent 2px),
      linear-gradient(90deg, var(--grid-color, rgba(0, 0, 0, 0.08)) 2px, transparent 2px);
    background-size: 40px 40px;
    background-position: -1px -1px;
  }

  .sk-grid-background-subtle {
    background-color: var(--bg-primary, #fafafa);
    background-image:
      linear-gradient(var(--grid-color, rgba(0, 0, 0, 0.04)) 1px, transparent 1px),
      linear-gradient(90deg, var(--grid-color, rgba(0, 0, 0, 0.04)) 1px, transparent 1px);
    background-size: 24px 24px;
  }

  .sk-grid-background-bold {
    background-color: var(--bg-primary, #f5f5f5);
    background-image:
      linear-gradient(var(--grid-color, rgba(0, 0, 0, 0.12)) 2px, transparent 2px),
      linear-gradient(90deg, var(--grid-color, rgba(0, 0, 0, 0.12)) 2px, transparent 2px);
    background-size: 48px 48px;
    background-position: -1px -1px;
  }

  /* Dark theme grid backgrounds */
  [data-theme="dark"] .sk-grid-background,
  .dark .sk-grid-background {
    --bg-primary: #0a0a0a;
    --grid-color: rgba(255, 255, 255, 0.06);
  }

  [data-theme="dark"] .sk-grid-background-bold,
  .dark .sk-grid-background-bold {
    --bg-primary: #0a0a0a;
    --grid-color: rgba(255, 255, 255, 0.1);
  }

  /* Bold Monochrome Card Styles */
  .sk-card {
    background: #ffffff;
    border: 2px solid #e5e5e5;
    border-radius: 12px;
    transition: all 0.2s ease;
  }

  .sk-card:hover {
    border-color: #171717;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  }

  .sk-card-elevated {
    background: #ffffff;
    border: 2px solid #171717;
    border-radius: 12px;
    box-shadow: 4px 4px 0 #171717;
    transition: all 0.15s ease;
  }

  .sk-card-elevated:hover {
    transform: translate(-2px, -2px);
    box-shadow: 6px 6px 0 #171717;
  }

  /* Dark theme cards */
  [data-theme="dark"] .sk-card,
  .dark .sk-card {
    background: #171717;
    border-color: #2a2a2a;
    box-shadow: 0 0 0 1px rgba(0, 200, 224, 0.1);
  }

  [data-theme="dark"] .sk-card:hover,
  .dark .sk-card:hover {
    border-color: #00c8e0;
    box-shadow: 0 0 20px rgba(0, 200, 224, 0.3), 0 0 40px rgba(0, 200, 224, 0.1);
  }

  [data-theme="dark"] .sk-card-elevated,
  .dark .sk-card-elevated {
    background: #171717;
    border-color: #00c8e0;
    box-shadow: 4px 4px 0 #00c8e0, 0 0 20px rgba(0, 200, 224, 0.2);
  }

  /* Neon Edge Highlights */
  .sk-neon-edge-left {
    position: relative;
  }

  .sk-neon-edge-left::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 2px;
    background: linear-gradient(180deg, #00c8e0, #00b4d8, #00c8e0);
    box-shadow: 0 0 10px #00c8e0, 0 0 20px rgba(0, 200, 224, 0.5), 0 0 30px rgba(0, 200, 224, 0.3);
  }

  .sk-neon-edge-right {
    position: relative;
  }

  .sk-neon-edge-right::before {
    content: '';
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    width: 2px;
    background: linear-gradient(180deg, #00c8e0, #00b4d8, #00c8e0);
    box-shadow: 0 0 10px #00c8e0, 0 0 20px rgba(0, 200, 224, 0.5), 0 0 30px rgba(0, 200, 224, 0.3);
  }

  .sk-neon-edge-top {
    position: relative;
  }

  .sk-neon-edge-top::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: linear-gradient(90deg, transparent, #00c8e0, #00b4d8, #00c8e0, transparent);
    box-shadow: 0 0 10px #00c8e0, 0 0 20px rgba(0, 200, 224, 0.5), 0 0 30px rgba(0, 200, 224, 0.3);
  }

  .sk-neon-edge-bottom {
    position: relative;
  }

  .sk-neon-edge-bottom::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: linear-gradient(90deg, transparent, #00c8e0, #00b4d8, #00c8e0, transparent);
    box-shadow: 0 0 10px #00c8e0, 0 0 20px rgba(0, 200, 224, 0.5), 0 0 30px rgba(0, 200, 224, 0.3);
  }

  /* Neon glow container */
  .sk-neon-glow {
    box-shadow: 0 0 15px rgba(0, 200, 224, 0.3),
                0 0 30px rgba(0, 200, 224, 0.15),
                inset 0 0 15px rgba(0, 200, 224, 0.05);
    border-color: rgba(0, 200, 224, 0.5) !important;
  }

  .sk-neon-glow-intense {
    box-shadow: 0 0 20px rgba(0, 200, 224, 0.5),
                0 0 40px rgba(0, 200, 224, 0.25),
                0 0 60px rgba(0, 200, 224, 0.1),
                inset 0 0 20px rgba(0, 200, 224, 0.08);
    border-color: #00c8e0 !important;
  }

  /* Stat Card Styling */
  .sk-stat-card {
    background: #ffffff;
    border: 2px solid #e5e5e5;
    border-radius: 16px;
    padding: 24px;
    position: relative;
    overflow: hidden;
    transition: all 0.2s ease;
  }

  .sk-stat-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: #171717;
  }

  .sk-stat-card:hover {
    border-color: #171717;
    transform: translateY(-2px);
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.1);
  }

  /* Dark theme stat cards */
  [data-theme="dark"] .sk-stat-card,
  .dark .sk-stat-card {
    background: #171717;
    border-color: #2a2a2a;
  }

  [data-theme="dark"] .sk-stat-card::before,
  .dark .sk-stat-card::before {
    background: linear-gradient(90deg, #00c8e0, #00b4d8);
  }

  [data-theme="dark"] .sk-stat-card:hover,
  .dark .sk-stat-card:hover {
    border-color: #00c8e0;
  }

  /* Typography */
  .sk-heading-xl {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
    font-weight: 800;
    font-size: 3rem;
    letter-spacing: -0.03em;
    line-height: 1.1;
  }

  .sk-heading-lg {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
    font-weight: 700;
    font-size: 2rem;
    letter-spacing: -0.02em;
    line-height: 1.2;
  }

  .sk-heading-md {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
    font-weight: 600;
    font-size: 1.25rem;
    letter-spacing: -0.01em;
  }

  .sk-label {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
    font-weight: 500;
    font-size: 0.75rem;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: #737373;
  }

  /* Buttons */
  .sk-btn-primary {
    background: #171717;
    color: #ffffff;
    border: 2px solid #171717;
    border-radius: 8px;
    padding: 12px 24px;
    font-weight: 600;
    font-size: 0.875rem;
    cursor: pointer;
    transition: all 0.15s ease;
  }

  .sk-btn-primary:hover {
    background: #000000;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  }

  .sk-btn-secondary {
    background: transparent;
    color: #171717;
    border: 2px solid #171717;
    border-radius: 8px;
    padding: 12px 24px;
    font-weight: 600;
    font-size: 0.875rem;
    cursor: pointer;
    transition: all 0.15s ease;
  }

  .sk-btn-secondary:hover {
    background: #171717;
    color: #ffffff;
  }

  /* Dark theme buttons */
  [data-theme="dark"] .sk-btn-primary,
  .dark .sk-btn-primary {
    background: #00c8e0;
    color: #0a0a0a;
    border-color: #00c8e0;
  }

  [data-theme="dark"] .sk-btn-primary:hover,
  .dark .sk-btn-primary:hover {
    background: #41e2f7;
    border-color: #41e2f7;
  }

  [data-theme="dark"] .sk-btn-secondary,
  .dark .sk-btn-secondary {
    color: #00c8e0;
    border-color: #00c8e0;
  }

  [data-theme="dark"] .sk-btn-secondary:hover,
  .dark .sk-btn-secondary:hover {
    background: #00c8e0;
    color: #0a0a0a;
  }

  /* Table Styles */
  .sk-table {
    border: 2px solid #e5e5e5;
    border-radius: 12px;
    overflow: hidden;
  }

  .sk-table-header {
    background: #f5f5f5;
    border-bottom: 2px solid #e5e5e5;
  }

  .sk-table-row {
    border-bottom: 1px solid #e5e5e5;
    transition: background 0.15s ease;
  }

  .sk-table-row:hover {
    background: #fafafa;
  }

  .sk-table-row:last-child {
    border-bottom: none;
  }

  /* Dark theme tables */
  [data-theme="dark"] .sk-table,
  .dark .sk-table {
    border-color: #2a2a2a;
  }

  [data-theme="dark"] .sk-table-header,
  .dark .sk-table-header {
    background: #1a1a1a;
    border-color: #2a2a2a;
  }

  [data-theme="dark"] .sk-table-row,
  .dark .sk-table-row {
    border-color: #2a2a2a;
  }

  [data-theme="dark"] .sk-table-row:hover,
  .dark .sk-table-row:hover {
    background: #1a1a1a;
  }

  /* Status Chips */
  .sk-chip {
    display: inline-flex;
    align-items: center;
    padding: 4px 12px;
    border-radius: 6px;
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.03em;
  }

  .sk-chip-active {
    background: #dcfce7;
    color: #166534;
    border: 1px solid #86efac;
  }

  .sk-chip-pending {
    background: #fef9c3;
    color: #854d0e;
    border: 1px solid #fde047;
  }

  .sk-chip-error {
    background: #fee2e2;
    color: #991b1b;
    border: 1px solid #fca5a5;
  }

  .sk-chip-default {
    background: #f5f5f5;
    color: #525252;
    border: 1px solid #d4d4d4;
  }

  /* Dark theme chips */
  [data-theme="dark"] .sk-chip-active,
  .dark .sk-chip-active {
    background: rgba(0, 200, 224, 0.15);
    color: #00c8e0;
    border-color: rgba(0, 200, 224, 0.3);
  }

  [data-theme="dark"] .sk-chip-default,
  .dark .sk-chip-default {
    background: #2a2a2a;
    color: #a3a3a3;
    border-color: #3a3a3a;
  }

  /* Progress Bars */
  .sk-progress {
    height: 8px;
    background: #e5e5e5;
    border-radius: 4px;
    overflow: hidden;
  }

  .sk-progress-bar {
    height: 100%;
    background: #171717;
    border-radius: 4px;
    transition: width 0.3s ease;
  }

  [data-theme="dark"] .sk-progress,
  .dark .sk-progress {
    background: #2a2a2a;
  }

  [data-theme="dark"] .sk-progress-bar,
  .dark .sk-progress-bar {
    background: linear-gradient(90deg, #00c8e0, #00b4d8);
  }

  /* Scrollbar Styling */
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background: #d4d4d4;
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #a3a3a3;
  }

  [data-theme="dark"] ::-webkit-scrollbar-thumb,
  .dark ::-webkit-scrollbar-thumb {
    background: #3a3a3a;
  }

  [data-theme="dark"] ::-webkit-scrollbar-thumb:hover,
  .dark ::-webkit-scrollbar-thumb:hover {
    background: #4a4a4a;
  }
`;

export default GlobalStyles;
